const HonoraireListePartenaireTech = ({}) => {

    return (
        <>
            
        </>
    )
}

export default HonoraireListePartenaireTech;